import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import { Button } from '@/shared/presentation/components/ui/Button';
import { FormErrorMessage } from '@/shared/presentation/components/ui/ErrorMessage';
import { Input } from '@/shared/presentation/components/ui/Input';

import { ForgetPassFlowModal } from './ForgetPassFlowModal';
import { ForgotPassViewModel } from './ForgotPass.vm';

const Form = styled.form`
  gap: 1.5rem;
  padding-right: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 8px;
`;

const EmailSentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 6rem;
  color: #636363;
  align-self: flex-start;
`;

type Props = Partial<{
  title?: string;
  onClose?: () => void;
}>;

export const ForgotPass: React.FC<Props> = observer((props) => {
  const vm = useViewModel(ForgotPassViewModel);

  const forgotPass = (e) => {
    e.preventDefault();
    vm.forgotPass();
  };

  if (vm.emailSent) {
    return (
      <ForgetPassFlowModal title="Email enviado" onClose={props.onClose}>
        <EmailSentContainer>
          <p>
            O email foi enviado para <strong>{vm.form.values.email}</strong> com um link para
            definir nova senha.
          </p>
          <p>Caso não tenha recebido, verifique a pasta Lixo Eletrônico/Spam.</p>
        </EmailSentContainer>
      </ForgetPassFlowModal>
    );
  }

  return (
    <ForgetPassFlowModal
      title="Nova Senha"
      subtitle="Enviaremos as instruções por email para você definir nova senha."
      onClose={props.onClose}
    >
      <Form onSubmit={forgotPass}>
        {vm.errorMessage && <FormErrorMessage>{vm.errorMessage}</FormErrorMessage>}
        <Input
          placeholder="Digite seu email"
          label="E-mail"
          name="email"
          errorMessage={vm.form.errors.email && vm.form.errors.email[0]}
          onChange={(value) => vm.form.setValue('email', value)}
          onBlur={() => vm.form.validateField('email')}
        />
        <Button loading={vm.isSubmitting} disabled={!vm.form.isValid || vm.isSubmitting}>
          Enviar email
        </Button>
      </Form>
    </ForgetPassFlowModal>
  );
});
